import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // Don't set default Content-Type - let axios handle it based on data type
  // headers: { 'Content-Type': 'application/json' },
  //withCredentials: true, // if you're using cookies
});

export default apiClient;
